import React, {useEffect, useState} from 'react';
import $ from "jquery";
import CustomDataTable from "../CustomDataTable";
import {trans} from "../../utils";

const Attachment = ({sendRequest,params,data,dataDocument,dataDocumentType}) =>{

    const [attachment, setAttachment] = useState({
        title:'',
        attachment_file:'',
        document_category_parent_id:'-1',
        document_category_child_id:'-1',
    });

    const [chainedDocType , setChainedDocType] = useState([]);

    const columns = [
        {data :"title",title:"Title"},
        {data :"parent.title",title:"Documentation Group"},
        {data :"child.title",title:"Documentation Type"},
        {data :"attachment_url",title:"File"}
    ];
    const handleTitleChange = event =>{
        setAttachment({...attachment,title: event.target.value} );
    }

    const handleGroupChange = event => {
        setAttachment({...attachment,document_category_parent_id: event.target.value} );
        let types = dataDocumentType.filter(el=>el.asset_item_documentation_group_id == event.target.value);
        setChainedDocType(types);
    }

    const handleTypeChange = event => {
        setAttachment({...attachment,document_category_child_id: event.target.value} );
    }

    const handleAttachmentFileChange = event =>{
        let files = event.target.files || event.dataTransfer.files;
        setAttachment({...attachment,attachment_file: files[0]} );
    }
    const handleAttachmentsForm = event =>
    {
        event.preventDefault();
        sendRequest(attachment,"WorkOrderAttachment",function (){
            $("#attachment").DataTable().ajax.reload()
            setAttachment({
                title:'',
                attachment_file:'',
                document_category_parent_id:'-1',
                document_category_child_id:'-1'
            })
            document.getElementById("attachment_file").value = null
        })
    }

    return(
       <>
            <div className="card-header cursor-pointer">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{trans('Attachments')}</h3>
                </div>
                {
                <div className="d-flex my-4">
                    { data.status_data  &&
                    data.status_data.title_en == "Active" && (data.is_assignee || data.is_admin) &&
                    <button type="button" className="btn btn btn-light-primary waves-effect waves-light" data-toggle="modal" data-target="#AttachmentModal">
                        <i className="bi bi-plus fs-3"></i> {trans('Add a new Attachments')}
                    </button>}
                </div>}
            </div>
           <div className="modal fade" id="AttachmentModal" tabIndex="-1" role="dialog"
                aria-labelledby="AttachmentModalLabel" aria-hidden="true">
               <div className="modal-dialog" role="document">
                   <div className="modal-content">
                       <div className="modal-header">
                           <h5 className="modal-title" id="exampleModalLabel">{trans('Add a new attachment')}</h5>
                           <button type="button" className="close" data-dismiss="modal"
                                   aria-label="Close">
                               <span aria-hidden="true">&times;</span>
                           </button>
                       </div>
                       <form onSubmit={handleAttachmentsForm} encType="multipart/form-data">

                           <div className="modal-body">

                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('title')} :</label>
                                   <input
                                       className="form-control"
                                       type="text" name="title"  value={attachment.title}
                                       onChange={handleTitleChange}
                                       autoFocus required />
                               </div>
                               <div className="form-group">
                                   <label htmlFor="recipient-name"
                                          className="col-form-label">{trans('Document Group')} :</label>
                                   <select className="form-select form-select-sm"
                                           aria-label=".form-select-sm example"
                                           type="text" name="assign"
                                           onChange={handleGroupChange}
                                           value={attachment.document_category_parent_id}
                                           required
                                   >
                                       <option value="-1"  selected disabled>{trans('Select an option')}</option>
                                       {dataDocument.map(title => (
                                           <option key={title.id} value={title.id} >{trans(title.title)}</option>
                                       ))}
                                   </select>
                               </div>
                               <div className="form-group">
                                   <label htmlFor="recipient-name"
                                          className="col-form-label">{trans('Document Type')} :</label>
                                   <select className="form-select form-select-sm"
                                           aria-label=".form-select-sm example"
                                           type="text" name="assign"
                                           onChange={handleTypeChange}
                                           value={attachment.document_category_child_id}
                                           required
                                   >
                                       <option value="-1" selected disabled>{trans('Select an option')}</option>
                                       {chainedDocType.map(title => (
                                           <option key={title.id} value={title.id} >{trans(title.title)}</option>
                                       ))}
                                   </select>
                               </div>
                               <div className="form-group">
                                   <label htmlFor="message-text"
                                          className="col-form-label">{trans('Attachment')} :</label>
                                   <input
                                       className="form-control"
                                       type="file" name="attachment_file"
                                       id="attachment_file"
                                       onChange={handleAttachmentFileChange}
                                       autoFocus required />
                               </div>
                           </div>
                           <div className="modal-footer">
                               <button type="button" className="btn btn-secondary"
                                       data-dismiss="modal">{trans('Close')}
                               </button>
                               <button onClick={handleAttachmentsForm} className="btn btn-primary"  data-dismiss="modal" type="submit">{trans('Submit')}</button>
                           </div>
                       </form>
                   </div>
               </div>
           </div>
            <div className="card-body p-9">
                <CustomDataTable columns={columns} url={"WorkOrderAttachment?wo_id="+params.id+"&include=parent,child"} table_id="attachment" />
            </div>
        </>
    )

}
export default Attachment
